<template>
    <defaultSec class="work-order-list">
        <template #title>
            <div  class="default-header" style="display: flex;justify-content: space-between">
                <h3>舆情管理</h3>
                <el-button plain icon="el-icon-date" size="mini" type="danger" @click="dialogVisible = true">舆情汇总数据</el-button>
            </div>
        </template>
        <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">

            <el-form-item label="短链接">
                <el-input v-model="formParam.shortUrl" placeholder="请填写" clearable></el-input>
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="formParam.userName" placeholder="请填写" clearable></el-input>
            </el-form-item>
            <el-form-item label="账号">
                <el-input v-model="formParam.account" placeholder="请填写" clearable></el-input>
            </el-form-item>
            <el-form-item label="笔记标题">
                <el-input v-model="formParam.noteTitle" placeholder="请填写" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否取得联系方式">
                <el-radio-group v-model="formParam.isGetNumber" size="small">
                    <el-radio-button label="是">是</el-radio-button>
                    <el-radio-button label="否">否</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="跟进状态">
                <el-select clearable filterable v-model="formParam.isDeleteNote" placeholder="请选择">
                    <el-option
                        v-for="item in dictionaryList.isDeleteNote||[]"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="initList">查询</el-button>
                <el-button type="warning" @click="toDetail(0)">新建舆情</el-button>
            </el-form-item>
        </el-form>
        <tablePagination :total="total" :pageSize="formParam.pageSize" :currentPage="formParam.pageNum" @handlePage="handlePage">
            <el-table v-loading="loading" :data="tableList" border size="mini">
                <el-table-column fixed="left" type="index" label="序号"></el-table-column>
                <el-table-column fixed="left" prop="source" label="来源"></el-table-column>
                <el-table-column fixed="left" width="150" prop="shortUrl" label="短链接">
                    <template slot-scope="scope">
                        {{scope.row.shortUrl}}<i style="color: #55a532;cursor: pointer" @click="copyOrderNo(scope.row.shortUrl)" class="el-icon-document-copy"></i>
                    </template>
                </el-table-column>
                <el-table-column fixed="left" width="140" prop="publishTime" label="发布时间"></el-table-column>
                <el-table-column width="240" label="舆情详情描述">
                    <template slot-scope="scope">
                        <div style="font-size: 10px;font-style: italic">
                            <span :style="{color:'#e50011'}">● </span>用户名：{{scope.row.userName}}
                        </div>
                        <div style="font-size: 10px;font-style: italic">
                            <span :style="{color:'#e50011'}">● </span>粉丝数：{{scope.row.fansCount}}
                        </div>
                        <div style="font-size: 10px;font-style: italic">
                            <span :style="{color:'#e50011'}">● </span>IP属地：{{scope.row.address}}
                        </div>
                        <div style="font-size: 10px;font-style: italic">
                            <span :style="{color:'#e50011'}">● </span>笔记标题：{{scope.row.noteTitle}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="chargePerson" label="负责伙伴"></el-table-column>
                <el-table-column prop="userAppeal" label="用户诉求"></el-table-column>
                <el-table-column prop="productName" label="反馈商品"></el-table-column>
                <el-table-column prop="solution" label="赔付和补偿方案"></el-table-column>
                <el-table-column prop="complaintContent" label="投诉内容"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column width="138" prop="noteMessageTime" label="笔记下面留言时间"></el-table-column>
                <el-table-column width="138" prop="noteReplyTime" label="笔记下面回复时间"></el-table-column>
                <el-table-column width="138" prop="privateMessageTime" label="私信联系时间"></el-table-column>
                <el-table-column width="138" prop="privateFirstReplyTime" label="私信首次回复时间"></el-table-column>
                <el-table-column width="138" prop="privateMessageHalfdayTime" label="12小时后个人号联系时间"></el-table-column>
                <el-table-column width="138" prop="privateFirstReplyHalfdayTime" label="12小时后个人号回复时间"></el-table-column>
                <el-table-column width="138" prop="privateFirstReplyDayTime" label="24小时内未回复评论留言时间"></el-table-column>
                <el-table-column width="138" prop="officialAccountMessageTime" label="官方账号留言时间"></el-table-column>
                <el-table-column width="138" prop="officialAccountReplyTime" label="官方账号回复时间"></el-table-column>
                <el-table-column prop="isGetNumber" label="是否取得联系方式"></el-table-column>
                <el-table-column width="138" prop="getNumberTime" label="获取到联系方式时间"></el-table-column>
                <el-table-column width="150" prop="number" label="电话or微信"></el-table-column>
                <el-table-column prop="isDeleteNote" label="跟进状态"></el-table-column>
                <el-table-column prop="deleteNoteTime" label="删帖日期"></el-table-column>
<!--                <el-table-column label="状态">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-tag :type="scope.row.status==1?'success':'danger'">{{scope.row.status==1?'有效':'已删除'}}</el-tag>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column label="操作" fixed="right" width="90">
                    <template slot-scope="scope">
                        <el-button style="margin-right: 8px" type="text" circle plain icon="el-icon-edit" size="mini" @click="toDetail(scope.row.id)"></el-button>
                        <el-popconfirm
                            title="确定要删除这条数据吗？"
                            @confirm="delSentiment(scope.row.id)"
                        >
                            <el-button slot="reference" type="text" style="color: red" plain circle icon="el-icon-delete" size="mini"></el-button>

                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </tablePagination>
        <el-dialog
            title="舆情汇总信息"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            width="70%">
            <el-descriptions border :column="1">
                <el-descriptions-item label="选择日期范围">

                    <el-date-picker
                        @change="getTotalInfo"
                        v-model="infoTime"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item label="汇总结果">
                    <template v-if="resultInfo">
                        <el-button type="danger" plain size="mini" icon="el-icon-copy-document" @click="copyOrderNo(resultInfo)">复制</el-button>
                    </template>
                    <el-empty v-else :image-size="80"></el-empty>

                    <div style="white-space: pre-line;margin-top: 20px;padding-left: 10px;" v-html="resultInfo"></div>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </defaultSec>
</template>

<script>
import defaultSec from '@c/defaultSection'
import tablePagination from '@c/tablePagination'
export default {
    name: "publicSentimentList",/*此处的name必须有且与include中的一致*/
    data() {
        return {
            formParam:{
                pageSize:10,
                pageNum:Number(this.$route.params.pageNum)||1,
            },
            tableList:[],
            total:0,
            dialogVisible:false,
            loading:true,
            dictionaryList:{
                source:[],
                questionType:[],
                isGetNumber:[],
                isDeleteNote:[],
            },
            infoTime:[],
            resultInfo:''
        }
    },
    components:{
        defaultSec,tablePagination
    },
    mounted(){
        this.initList()
        this.initDictionaryList()

    },
    methods: {
        initList() {
            this.loading = true
            let param = {...this.formParam};
            this.$apiGet('lechun-csms/xhs/getPublicSentimentPageList',param).then(res => {
                console.log(res)
                this.loading = false
                this.total = res.total;
                this.tableList = res.list

            })
        },
        initDictionaryList() {
            this.$apiGet('lechun-csms/xhs/getDictionaryList',{}).then(res => {
                console.log(res)
                this.dictionaryList = res
            })
        },
        delSentiment(id) {
            this.$apiGet('lechun-csms/xhs/deletePublicSentimentById',{ id:id}).then(res => {
                console.log(res)
                this.$message({
                    message: '删除成功',
                    type: 'success'
                })
                this.initList()

            })
        },
        getTotalInfo() {
            let startTime = this.infoTime[0]
            let endTime = this.infoTime[1]
            this.$apiGet('lechun-csms/xhs/getTotalInfo',{  startTime,endTime}).then(res => {
                console.log(res)
                this.$message({
                    message: '获取成功',
                    type: 'success'
                })
                for(let key in res){
                    this.resultInfo += key+': '+res[key]+' ;\n'
                }

            })
        },
        handleClose(){
            this.resultInfo  = ''
            this.infoTime  = []
            this.dialogVisible  = false
        },
        handlePage(page){
            this.formParam.pageNum = page;
            this.$router.push({
                name: 'publicSentimentList',
                params: {pageNum: page}
            })
            this.initList()

        },
        toDetail(id){
            this.$router.push({
                name: 'publicSentimentDetail',
                params: {id: id},
                query: {
                    editAble: 1
                }
            })
        },
        copyOrderNo(text){
            var input = document.createElement("textarea"); // 创建input对象
            input.value = text; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message({
                type: 'success',
                message: '已复制到剪贴板'
            });
        },
    }
}
</script>


<style lang="scss">
.work-order-list{
    .label-text{
        display: flex;
        margin-bottom: 5px;
        b{
            width: 60px;
            display: block;
            text-align: right;
            font-weight: normal;
        }
        >span{
            flex: 1;
            font-weight: bolder;
        }
    }
    .copy-text {
        display: block;
        white-space: pre-line;
        margin: 0;
        line-height: 18px;
        background: #f2f2f2;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding: 6px;
        max-height: 127px;
        overflow-y: scroll;
    }
}

.response-dept{
    .el-button--small{
        padding: 4px 10px;
    }
}
</style>